import { useRef, useEffect } from 'react';

import { AppIcon } from '@backrs_ui/common-ui';

import { Box, TextField, Typography } from '@mui/material';

import {
  headerSx,
  headerRowSx,
  searchContainerSx,
  searchInputSx,
  closeButtonSx,
  titleSx,
} from './CommandPalette.styles';

export const COMMAND_PALETTE_TITLE_ID = 'command-palette-title';

export interface CommandPaletteSearchProps {
  title?: string;
  searchPlaceholder?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onClose: () => void;
  autoFocus?: boolean;
}

export const CommandPaletteSearch = ({
  title,
  searchPlaceholder = 'Search...',
  searchValue,
  onSearchChange,
  onClose,
  autoFocus = true,
}: CommandPaletteSearchProps) => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [autoFocus]);

  const closeButton = (
    <Box id="command-palette-close" sx={closeButtonSx} onClick={onClose}>
      <AppIcon iconName="XClose" diameter="20px" color="Colors/Foreground/fg-quaternary" />
    </Box>
  );

  return (
    <Box sx={headerSx}>
      {title ? (
        <Box sx={headerRowSx}>
          <Typography id={COMMAND_PALETTE_TITLE_ID} variant="text-md-semibold" sx={titleSx}>
            {title}
          </Typography>
          {closeButton}
        </Box>
      ) : null}
      <Box sx={headerRowSx}>
        <Box sx={searchContainerSx}>
          <AppIcon iconName="SearchMd" diameter="20px" color="Colors/Foreground/fg-tertiary" />
          <TextField
            id="command-palette-search"
            inputRef={searchInputRef}
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            fullWidth
            variant="standard"
            sx={searchInputSx}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>
        {title ? null : closeButton}
      </Box>
    </Box>
  );
};
